export default __webpack_public_path__ + "static/media/15.3a4803f9.jpg";